/** EN uses Swedish values until translated. */
export const watchListsTranslationsEn = {
    title: 'Watchlist',
    watch: 'Add to watchlist',
    addHeading: 'Add {{type}} to watchlist',
    searchPlaceholder: 'Search {{type}}',
    searchAdvisor: 'Search advisor',
    watchedHeading: 'Watched {{type}}',
    emptyMessage: 'You are not watching any {{type}}. Search for {{type}} to add to your watchlist.',
    removeTooltip: 'Remove {{name}} from watchlist',
    addedSuccess: '{{name}} was added to the watchlist.',
    alreadyExists: '{{name}} is already on the watchlist.',
    removedSuccess: '{{name}} was removed from the watchlist.',
    toggle: {
        label: 'Watchlist',
        watches: 'Watchlist contents',
    },
    groupLabels: {
        Issue: 'Issues',
        Warrant: 'Warrants',
        Company: 'Company',
        Investor: 'Investors',
        Convertible: 'Convertibles',
        Advisor: 'Advisor',
    },
}
